/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';
loadStyles([{"rawString":".clickableSharedField_39b651da{cursor:pointer}.clickableSharedField_39b651da:hover{text-decoration:underline}.sharedFieldRender_39b651da{text-decoration:none;text-overflow:ellipsis;overflow:hidden}\n"}]);
export const clickableSharedField = "clickableSharedField_39b651da";
export const sharedFieldRender = "sharedFieldRender_39b651da";